import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "15",
  fill: "none",
  viewBox: "0 0 21 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 7.499 7.386 0 8.74 1.376 3.67 6.526H21v1.946H3.67l5.07 5.152L7.387 15 0 7.499Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }